<div class="drop-zone">
  <input class="box__file" type="file" id="file" [multiple]="multiple" [accept]="accept" [disabled]="disabled" (change)="handleFileSelected($event)" />
  <ng-content></ng-content>
</div>
